import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { InputRestrictionDirective } from './directives/special-char-input.directive';
import { WholeNumbersOnlyDirective } from './directives/whole-numbers-only.directive';
import { DecimalNumbersDirective } from './directives/decimal-numbers.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectHelpers } from './services/selectHelpers';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {DocumentPdfViewerComponent} from "./components/document-pdf-viewer/document-pdf-viewer.component";

@NgModule({
  declarations: [
    PhoneMaskDirective,
    InputRestrictionDirective,
    WholeNumbersOnlyDirective,
    DecimalNumbersDirective,
    DocumentPdfViewerComponent
  ],
  exports: [
    PhoneMaskDirective,
    InputRestrictionDirective,
    WholeNumbersOnlyDirective,
    DecimalNumbersDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule
  ],
  providers: [
    SelectHelpers
  ]
})
export class SharedModule {}
